/*
 * Computes the initial compass bearing (in degrees clockwise from north) from
 * one lat/lon point to another.
 *
 * Equivalent to google.maps.geometry.spherical.computeHeading, reimplemented
 * here so the Street View panorama can face the property without pulling in the
 * Google Maps geometry library.
 */
export const computeHeading = (from: { lat: number; lon: number }, to: { lat: number; lon: number }): number => {
  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

  const fromLat = toRadians(from.lat);
  const toLat = toRadians(to.lat);
  const deltaLon = toRadians(to.lon - from.lon);

  const y = Math.sin(deltaLon) * Math.cos(toLat);
  const x = Math.cos(fromLat) * Math.sin(toLat) - Math.sin(fromLat) * Math.cos(toLat) * Math.cos(deltaLon);

  const headingDegrees = (Math.atan2(y, x) * 180) / Math.PI;

  // Normalise to the 0-360 range Street View expects.
  return (headingDegrees + 360) % 360;
};
